export default {
  setup() {
    console.log("home");
    return {};
  }
};